import React, {useEffect, useState, useRef, useMemo} from 'react'
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import {toast} from "react-toastify";
import {Button} from 'react-bootstrap';
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import "./journey.css";
import useCurrentlocation from "../../hooks/currentlocation/useCurrentlocation";
import {generateRandomString, versionCheck} from "../Common";
import {geocode, appendLocationInImage} from "../Geocode";

const Journey = ({
                     save,
                     journeyDetails,
                     documentUploadUrlPublic,
                     documentUrlDataPublic = [],
                     match,
                     history,
                     getUserJourney = [],
                     getJourney
                 }) => {

    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        formatted_address: null,
        lat: 0,
        lng: 0,
    });
    const canvasRef = useRef(null);
    const [isAllow, setIsAllow] = useState(false);
    const islatlng = useCurrentlocation();
    const [comments, setComments] = useState("")
    const [selfie, setSelfie] = useState('')
    const [selfieUrl, setSelfieUrl] = useState("");
    const [retake, setRetake] = useState(true);
    const [roleId, setRoleId] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [journeyType, setJourneyType] = useState('Start')
    const [journeyId, setJourneyId] = useState('')
    const [mockSetLocation, setMockSetLocation] = useState();
    const [isMobile, setIsMobile] = useState(false);
    const [isLocationFetching, setIsLocationFetching] = useState(false);
    const [locationStatus, setLocationStatus] = useState(null)
    const currentUserLocation = useRef(null);

    useEffect( async () => {
        const webView = window.localStorage?.webview;
        if(versionCheck('3.0.0')){
            if(webView !== undefined && webView == 'true') {
                setIsLocationFetching(true);
                getUserLocation();
            } else {
                setIsLoading(true);
                setLocationStatus('granted');
                currentUserLocation.current = await getLocation();
                console.log("currentUserLocation.current", currentUserLocation.current)
                setIsLocationFetching(false);
                setIsLoading(false)
            }
        }
    }, []);

    useEffect(async () => {
        setRoleId(window.localStorage.role_id)
        let userProfile = localStorage.getItem('user_profile')
        let userDetails = JSON.parse(userProfile)
        const teamIds = userDetails?.teams.map(team => team.team_id);
        let module_type = '';
        console.log(teamIds)
        if (parseInt(window?.localStorage?.role_id) === 29 || parseInt(window?.localStorage?.role_id) === 30 || parseInt(window?.localStorage?.role_id) === 43) {
            module_type = "fasttag toll"
        } else if ((teamIds && teamIds.includes(18)) && (parseInt(window?.localStorage?.role_id) === 42 || parseInt(window?.localStorage?.role_id) === 41 || parseInt(window?.localStorage?.role_id) === 6)) {
            module_type = "dealer"
        } else if ((teamIds && teamIds.includes(28)) && (parseInt(window?.localStorage?.role_id) === 42 || parseInt(window?.localStorage?.role_id) === 41 || parseInt(window?.localStorage?.role_id) === 6)) {
            module_type = "UCD";
        }

        if (module_type) {
            await getJourney(module_type)
        }

        setTimeout(() => {
            setSelfieUrl("")
        }, 1000)
    }, [])

      useEffect( () => {
        if (selfie !== '' && canvasRef.current) {
            let canvas = canvasRef.current;
            (async () => {
                setIsLoading(true);
                if(versionCheck('3.0.0')){
                    const address = await geocode(currentUserLocation?.current?.lat, currentUserLocation?.current?.long);
                    appendLocationInImage(currentUserLocation?.current?.lat, currentUserLocation?.current?.long, address, canvas, selfie, documentUploadUrlPublic);
                } else {
                    const address = await geocode(islatlng?.lat, islatlng?.lng);
                    appendLocationInImage(islatlng?.lat, islatlng?.lng, address ,canvas, selfie, documentUploadUrlPublic);
                }
                setIsLoading(false);
            })();
        }
    }, [selfie]);

    const memoizedCameraComponent = useMemo(() => {
        return (
            <Camera
                idealFacingMode={"user"}
                idealResolution={{ width: 600, height: 480 }}
                onTakePhoto={(dataUri) => {
                    setIsLoading(true)
                    setSelfie(dataUri);
                    setRetake(false)
                    setIsLoading(false)
                }}
            />
        );
    }, [retake]);

    useEffect(() => {
        if (getUserJourney?.data) {
            setJourneyType("End")
            window.localStorage.journey_state = 'End'
            setJourneyId(getUserJourney?.data?.id)
        }
    }, [getUserJourney])


    useEffect(() => {
        if (documentUrlDataPublic?.file_url !== undefined) {
            setSelfieUrl(documentUrlDataPublic?.file_url)
        }
    }, [documentUrlDataPublic])

    useEffect(() => {
        // Function to check window width and update state
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768); // Define the breakpoint for mobile
        };
    
        // Initial check on component mount
        handleResize();
    
        // Add event listener to detect window resize
        window.addEventListener('resize', handleResize);
    
        // Cleanup on component unmount
        return () => window.removeEventListener('resize', handleResize);
      }, []);

    useEffect(() => {
        if (parseInt(journeyDetails?.status) === 200) {
            toast.success(journeyDetails?.message)
            if (window.localStorage.journey_state === 'End') {
                delete window.localStorage.journey_state
            } else {
                window.localStorage.journey_state = 'End'
            }
            window.location.href = "/home"
        } else {
            toast.error(journeyDetails?.message)
        }
    }, [journeyDetails])


    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }

        if(islatlng?.is_mock){
            setMockSetLocation(true)
            toast.error(`Location morphing is cheating. ${journeyType} journey not allowed.`)
        }
    }, [islatlng]);
    const handleSubmitData = async () => {

        if (isAllow) {
            toast.error("In order to submit the form you need to allow the location first");
        }

        const data = {
            lat: currentUserLocation?.current?.lat ? currentUserLocation?.current?.lat : islatlng?.lat,
            long: currentUserLocation?.current?.long ? currentUserLocation?.current?.long : islatlng?.lng,
            module_type: window.localStorage.module_type
        };

        data['comments'] = comments
        data['check_type'] = journeyType
        data['id'] = journeyId
        data['selfie'] = selfieUrl
        data["device_id"] = null;
        if(window.localStorage?.device_id){
            data["device_id"] = window.localStorage.device_id;
        }

        data['device_info'] = null;
        if(window.localStorage?.webview){
            data['device_info'] = {
                'brand_name': window.localStorage?.brand_name,
                'model_name': window.localStorage?.model_name,
                'device_name': window.localStorage?.device_name,
                'device_os': window.localStorage?.device_os,
                'device_os_version': window.localStorage?.device_os_version,
            }
        }

        if (selfieUrl === '') {
            toast.error("Please take selfie")
            return false
        }

        if (data['lat'] === null || data['long'] === null) {
            toast.error("Please enable your location")
            return false
        }

        setIsLoading(true)
        await save(data)
        setIsLoading(false)
    };

    function locationCallback(data) {
        if (data.detail) {
            if (data?.detail?.gps_status === "granted") {
                if (data.detail.status === "granted") {
                    setLocationStatus("granted");
                    currentUserLocation.current = {
                        lat: data?.detail?.latitude,
                        long: data?.detail?.longitude,
                        is_mock: data.detail.mocked,
                        device_id: data.detail.device_id
                    }
                } else {
                    setLocationStatus("permission_denied");
                }
            } else {
                setLocationStatus("gps_denied");
            }
        }
        setIsLocationFetching(false);
    }

    const getUserLocation = () => {
        let eventName = `locationEvent${generateRandomString()}`;
        window.addEventListener(eventName, locationCallback)
        window.ReactNativeWebView.postMessage(JSON.stringify({
            event_name: "get_current_location",
            data: {
                accuracy: 4,
                callback_script: `
            try {
                window.dispatchEvent(new CustomEvent('${eventName}', {detail: {
                    gps_status: "__gps_status__",
                    status: "__status__",
                    mocked: __mocked__,
                    latitude: __latitude__,
                    longitude: __longitude__,
                    device_id: "__device_id__",
                }}))
            } catch (e) {
                console.warn('could not get error')
            }
        `
            }
        }));
        return () => {
            window.removeEventListener(eventName, locationCallback)
        }
    }

    function getLocation() {

        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
                    if (permissionStatus.state === 'denied') {
                        alert('Please allow location access.');
                        setIsLoading(false);
                        setIsLocationFetching(false);
                        reject('Location access denied.');
                    } else {
                        navigator.geolocation.getCurrentPosition(
                            (success) => {
                                if (success?.coords && success.coords.latitude) {
                                    const location = {
                                        lat: success.coords.latitude,
                                        long: success.coords.longitude,
                                        is_mock: false,
                                        device_id: ''
                                    };
                                    setIsLoading(false);
                                    resolve(location);
                                }
                            },
                            (error) => {
                                setIsLoading(false);
                                reject(error);
                            }
                        );
                    }
                }).catch(err => {
                    setIsLoading(false);
                    reject(err);
                });
            } else {
                setIsLoading(false);
                reject('Geolocation not supported.');
            }
        });
        setIsLoading(false);
    }

    const refreshUserLocation = async (e) => {
        e.preventDefault();
        const webView = window.localStorage?.webview;
        if(webView !== undefined && webView == 'true') {
            setIsLocationFetching(true);
            getUserLocation();
        } else {
            setIsLoading(true);
            setIsLocationFetching(true);
            setLocationStatus('granted')
            currentUserLocation.current = await getLocation();
            setIsLocationFetching(false);
            setIsLoading(false);
        }
    }

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.4.1/css/all.css"
                      integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz"
                      crossOrigin="anonymous"/>
                <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet"></link>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Journey'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <form className="attForm">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                            <h1 className="h3 mb-0 text-black-100">
                                                {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                                {/*<span style={{color: "green"}}> {distance}</span>*/}
                                            </h1>
                                        </div>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    <div className="col-sm-12 mt-1 float-field">
                                                        {/*<Speed/>*/}
                                                        <br/>

                                                        <div>{
                                                            isLocationFetching ? "Location fetching..." : ""
                                                        }</div>

                                                        {!versionCheck('3.0.0') &&
                                                            <>
                                                                Lat: {islatlng?.lat} {"\u00a0\u00a0"} Long: {islatlng?.lng}
                                                            </>

                                                        }
                                                    </div>
                                                    {versionCheck('3.0.0') &&
                                                        <div
                                                            className="d-flex justify-content-center align-items-center">{
                                                            locationStatus === "granted" && currentUserLocation?.current?.lat ?
                                                                <div>Lat: {parseFloat(currentUserLocation?.current?.lat).toFixed(6)} {"\u00a0\u00a0"} Long: {parseFloat(currentUserLocation?.current?.long).toFixed(6)}</div> :
                                                                <div>
                                                                    <div>You've denied GPS/permission, please allow it
                                                                        and then relaunch the
                                                                        application
                                                                    </div>
                                                                </div>
                                                        }
                                                            <button className="btn-sm float-right
                                            btn btn-primary" id="fetchLocation" onClick={(e) => refreshUserLocation(e)}
                                                             style={{width:"14%"}}>
                                                                <i className="bi bi-arrow-clockwise f-20px"></i>
                                                            </button>
                                                        </div>
                                                    }
                                                    <div className="col-sm-12 col-md-12  mt-1 float-field">
                                                        <canvas
                                                            ref={canvasRef}
                                                            width="100%"
                                                            height="520"
                                                            style={{
                                                                display: 'none',
                                                                border: '1px solid black',
                                                                marginTop: '20px'
                                                            }}
                                                        ></canvas>
                                                        {selfieUrl !== "" ? (
                                                            <img src={`${selfieUrl}`} alt={""} style={{width:"100%"}}/>
                                                        ) : (
                                                            retake && memoizedCameraComponent
                                                        )}
                                                    </div>
                                                    <div className="col-sm-12 mt-1 float-field">
                                                    <textarea
                                                        className="form-control form-control-user"
                                                        placeholder=" Description"
                                                        onChange={(e) => {
                                                            setComments(e.target.value)
                                                        }}
                                                        id="validationCustom01"
                                                        rows="4" cols="50"
                                                    />
                                                    </div>
                                                    <div className="col-sm-12 mt-1 float-field d-flex">
                                                    {isMobile ?
                                                        <>
                                                            <Button
                                                                className="btn-md"
                                                                onClick={() => handleSubmitData()}
                                                                disabled={mockSetLocation}
                                                            >
                                                                {journeyType}
                                                            </Button>

                                                            <Button
                                                                className="btn-sm float-right"
                                                                style={{marginLeft: "36%"}}
                                                                onClick={() => {
                                                                    setRetake(true)
                                                                    setSelfieUrl("")
                                                                    setSelfie("")
                                                                }
                                                                }
                                                            >
                                                                {"Retake"}
                                                            </Button>
                                                        </>
                                                         :
                                                         <div className="col-12" style={{"color" : "red"}}>Checkin is disable on desktop mode</div>
                                                         }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Journey